import { PanelBottomClose, PanelBottomOpen } from 'lucide-react';
import { useVersionInfo } from '../../hooks/useVersionInfo';
import { useUIStore } from '../../stores/uiStore';

export function VersionFooter() {
  const { frontend, backend, backendStatus } = useVersionInfo();
  const infoCollapsed = useUIStore((s) => s.infoCollapsed);
  const setInfoCollapsed = useUIStore((s) => s.setInfoCollapsed);

  const feLabel = frontend ? `FE v${frontend.version}` : 'FE v...';
  const beLabel = backend ? `BE v${backend.version}` : 'BE v...';
  const builtLabel =
    frontend?.built && frontend.built !== 'unknown'
      ? new Date(frontend.built).toLocaleString('en-US', {
          month: 'short',
          day: 'numeric',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
        })
      : null;

  return (
    <footer
      data-testid="vibe-version-footer"
      className="shrink-0 px-3 py-1 border-t border-slate-700 bg-slate-900/85 text-[10px] text-slate-400 flex items-center justify-between gap-3"
    >
      <div className="flex items-center gap-2">
        <span className="font-mono">Vibe Designer</span>
        <button
          type="button"
          data-testid="footer-toggle-info-panel"
          onClick={() => setInfoCollapsed(!infoCollapsed)}
          aria-pressed={!infoCollapsed}
          title={
            infoCollapsed
              ? 'Show the bottom panel (Problems / Output / Terminal / Git)'
              : 'Hide the bottom panel'
          }
          className={`flex items-center gap-1 px-1.5 py-0.5 rounded border transition-colors ${
            infoCollapsed
              ? 'border-slate-600 text-slate-400 hover:bg-slate-700/40 hover:text-slate-200'
              : 'border-vibe-accent/40 text-vibe-accent bg-vibe-accent/10'
          }`}
        >
          {infoCollapsed ? (
            <PanelBottomOpen className="w-3 h-3" />
          ) : (
            <PanelBottomClose className="w-3 h-3" />
          )}
          <span>Panel</span>
        </button>
      </div>
      <div className="flex items-center gap-2 font-mono">
        <span className="bg-slate-700/40 px-1.5 py-0.5 rounded border border-slate-600">
          {feLabel}
        </span>
        <span className="bg-slate-700/40 px-1.5 py-0.5 rounded border border-slate-600">
          {beLabel}
        </span>
        {builtLabel && (
          <span
            className="bg-amber-400/10 text-amber-400/60 px-1.5 py-0.5 rounded border border-amber-400/15"
            title={frontend?.built}
          >
            Built {builtLabel}
          </span>
        )}
      </div>
      <div className="flex items-center gap-1.5">
        <div
          className={`w-1.5 h-1.5 rounded-full ${
            backendStatus === 'connected'
              ? 'bg-green-500'
              : backendStatus === 'disconnected'
                ? 'bg-red-500'
                : 'bg-amber-500'
          }`}
        />
        <span className="capitalize">{backendStatus}</span>
      </div>
    </footer>
  );
}
